import React, {Component} from "react";
import moment from 'moment';

export default class DistanceRenderer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        }
    }


    render() {
        return (
            <span>{(this.state.value/1000).toFixed(2) + " KM"}</span>
        );
    }
};

